<template>
  <div>
    <breadcrumbs home="Tax"/>

    <v-card flat width="100%">
      <v-form v-model="valid" ref="form">
        <v-container class="px-6 pt-8 purtrak-scrollable" fluid>

          <v-row dense>
            <v-col cols="12" sm="6" md="5">
              <v-text-field label="Name" v-model="tax.name" :rules="[fieldRules.required,fieldRules.maxLength(50)]" :counter="50" outlined dense/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Active" v-model="tax.active" class="mt-1"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5" sm="2">
              <decimal-number-input label="Sales rate" v-model="tax.salesRate" prefix="" suffix="%" :precision="3"/>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5" sm="2">
              <decimal-number-input label="Purchase rate" v-model="tax.purchaseRate" prefix="" suffix="%" :precision="3"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'SettingsTaxesEdit',
  mixins: [confirmLeave],
  props: {
    taxId: {type:String, required:false}
  },
  data() {
    return {
      tax: {active:true,name:'',purchaseRate:0,salesRate:0},
      valid: true,
      dirty: false,
      saving: false
    }
  },
  watch: {
    tax: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    if (this.taxId) {
      const results = await this.$apiCall(`query SettingsTaxesEdit($id:ID!) {
                                                tax(id:$id) {
                                                  id,name,active,purchaseRate,salesRate
                                                }
                                              }`,
                                          {id:this.taxId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.tax = results.data.tax;
      this.$nextTick(() => this.dirty = false);
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const results = await this.$apiCall(`mutation SettingsTaxesEdit($input: TaxInput!) {
                                             taxCreate(input:$input) {id}
                                           }`,
                                          {input:this.tax})
      if (results.error)
        return;

      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.taxId?'Updated':'Created'} tax ${this.tax.name}`});
      });
    },
  }
}
</script>